import React from 'react';
import { Box, Paper, IconButton, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux';
import { creativeUploadActions } from '../../../../redux/reducers/creativeUploadReducer';

const SearchUsingFilter = () => {
    const dispatch = useDispatch();
    const handleSearch = (value) => {
        dispatch(creativeUploadActions.handleSearch({ searchTerm: value }));
    };

    return (
        <Box className="flex-row-space-between-center">
            {/* Search Box */}
            <Box>
                <Paper
                    className='no-box-shadow'
                    component="form"
                    sx={{
                        p: '2px 4px', display: 'flex', alignItems: 'center', width: {
                            md: 200, lg: 250, xl: 320 
                        }, border: '1px solid #D0D5DD', borderRadius: '8px' 
                    }}
                >
                    <IconButton aria-label="search" sx={{ p: '10px' }} type="button">
                        <SearchIcon />
                    </IconButton>
                    <InputBase
                        inputProps={{ 'aria-label': 'search google maps' }}
                        placeholder="Search"
                        sx={{ ml: 1, flex: 1 }}
                        onChange={(e)=>handleSearch(e.target.value)}
                    />
                </Paper>
            </Box>

        </Box>
    );
};

export default SearchUsingFilter;